/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.ZilliqaMessage = (function() {

    /**
     * Namespace ZilliqaMessage.
     * @exports ZilliqaMessage
     * @namespace
     */
    var ZilliqaMessage = {};

    ZilliqaMessage.ByteArray = (function() {

        /**
         * Properties of a ByteArray.
         * @memberof ZilliqaMessage
         * @interface IByteArray
         * @property {Uint8Array} data ByteArray data
         */

        /**
         * Constructs a new ByteArray.
         * @memberof ZilliqaMessage
         * @classdesc Represents a ByteArray.
         * @implements IByteArray
         * @constructor
         * @param {ZilliqaMessage.IByteArray=} [properties] Properties to set
         */
        function ByteArray(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ByteArray data.
         * @member {Uint8Array} data
         * @memberof ZilliqaMessage.ByteArray
         * @instance
         */
        ByteArray.prototype.data = $util.newBuffer([]);

        /**
         * Creates a new ByteArray instance using the specified properties.
         * @function create
         * @memberof ZilliqaMessage.ByteArray
         * @static
         * @param {ZilliqaMessage.IByteArray=} [properties] Properties to set
         * @returns {ZilliqaMessage.ByteArray} ByteArray instance
         */
        ByteArray.create = function create(properties) {
            return new ByteArray(properties);
        };

        /**
         * Encodes the specified ByteArray message. Does not implicitly {@link ZilliqaMessage.ByteArray.verify|verify} messages.
         * @function encode
         * @memberof ZilliqaMessage.ByteArray
         * @static
         * @param {ZilliqaMessage.IByteArray} message ByteArray message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ByteArray.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.data);
            return writer;
        };

        /**
         * Encodes the specified ByteArray message, length delimited. Does not implicitly {@link ZilliqaMessage.ByteArray.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ZilliqaMessage.ByteArray
         * @static
         * @param {ZilliqaMessage.IByteArray} message ByteArray message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ByteArray.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ByteArray message from the specified reader or buffer.
         * @function decode
         * @memberof ZilliqaMessage.ByteArray
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ZilliqaMessage.ByteArray} ByteArray
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ByteArray.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZilliqaMessage.ByteArray();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("data"))
                throw $util.ProtocolError("missing required 'data'", { instance: message });
            return message;
        };

        /**
         * Decodes a ByteArray message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ZilliqaMessage.ByteArray
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ZilliqaMessage.ByteArray} ByteArray
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ByteArray.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ByteArray message.
         * @function verify
         * @memberof ZilliqaMessage.ByteArray
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ByteArray.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
            return null;
        };

        /**
         * Creates a ByteArray message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ZilliqaMessage.ByteArray
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ZilliqaMessage.ByteArray} ByteArray
         */
        ByteArray.fromObject = function fromObject(object) {
            if (object instanceof $root.ZilliqaMessage.ByteArray)
                return object;
            var message = new $root.ZilliqaMessage.ByteArray();
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length)
                    message.data = object.data;
            return message;
        };

        /**
         * Creates a plain object from a ByteArray message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ZilliqaMessage.ByteArray
         * @static
         * @param {ZilliqaMessage.ByteArray} message ByteArray
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ByteArray.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            return object;
        };

        /**
         * Converts this ByteArray to JSON.
         * @function toJSON
         * @memberof ZilliqaMessage.ByteArray
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ByteArray.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ByteArray;
    })();

    ZilliqaMessage.ProtoTransactionCoreInfo = (function() {

        /**
         * Properties of a ProtoTransactionCoreInfo.
         * @memberof ZilliqaMessage
         * @interface IProtoTransactionCoreInfo
         * @property {number|null} [version] ProtoTransactionCoreInfo version
         * @property {number|Long|null} [nonce] ProtoTransactionCoreInfo nonce
         * @property {Uint8Array|null} [toaddr] ProtoTransactionCoreInfo toaddr
         * @property {ZilliqaMessage.IByteArray|null} [senderpubkey] ProtoTransactionCoreInfo senderpubkey
         * @property {ZilliqaMessage.IByteArray|null} [amount] ProtoTransactionCoreInfo amount
         * @property {ZilliqaMessage.IByteArray|null} [gasprice] ProtoTransactionCoreInfo gasprice
         * @property {number|Long|null} [gaslimit] ProtoTransactionCoreInfo gaslimit
         * @property {Uint8Array|null} [code] ProtoTransactionCoreInfo code
         * @property {Uint8Array|null} [data] ProtoTransactionCoreInfo data
         */

        /**
         * Constructs a new ProtoTransactionCoreInfo.
         * @memberof ZilliqaMessage
         * @classdesc Represents a ProtoTransactionCoreInfo.
         * @implements IProtoTransactionCoreInfo
         * @constructor
         * @param {ZilliqaMessage.IProtoTransactionCoreInfo=} [properties] Properties to set
         */
        function ProtoTransactionCoreInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProtoTransactionCoreInfo version.
         * @member {number} version
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @instance
         */
        ProtoTransactionCoreInfo.prototype.version = 0;

        /**
         * ProtoTransactionCoreInfo nonce.
         * @member {number|Long} nonce
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @instance
         */
        ProtoTransactionCoreInfo.prototype.nonce = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ProtoTransactionCoreInfo toaddr.
         * @member {Uint8Array} toaddr
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @instance
         */
        ProtoTransactionCoreInfo.prototype.toaddr = $util.newBuffer([]);

        /**
         * ProtoTransactionCoreInfo senderpubkey.
         * @member {ZilliqaMessage.IByteArray|null|undefined} senderpubkey
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @instance
         */
        ProtoTransactionCoreInfo.prototype.senderpubkey = null;

        /**
         * ProtoTransactionCoreInfo amount.
         * @member {ZilliqaMessage.IByteArray|null|undefined} amount
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @instance
         */
        ProtoTransactionCoreInfo.prototype.amount = null;

        /**
         * ProtoTransactionCoreInfo gasprice.
         * @member {ZilliqaMessage.IByteArray|null|undefined} gasprice
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @instance
         */
        ProtoTransactionCoreInfo.prototype.gasprice = null;

        /**
         * ProtoTransactionCoreInfo gaslimit.
         * @member {number|Long} gaslimit
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @instance
         */
        ProtoTransactionCoreInfo.prototype.gaslimit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ProtoTransactionCoreInfo code.
         * @member {Uint8Array} code
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @instance
         */
        ProtoTransactionCoreInfo.prototype.code = $util.newBuffer([]);

        /**
         * ProtoTransactionCoreInfo data.
         * @member {Uint8Array} data
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @instance
         */
        ProtoTransactionCoreInfo.prototype.data = $util.newBuffer([]);

        /**
         * Creates a new ProtoTransactionCoreInfo instance using the specified properties.
         * @function create
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @static
         * @param {ZilliqaMessage.IProtoTransactionCoreInfo=} [properties] Properties to set
         * @returns {ZilliqaMessage.ProtoTransactionCoreInfo} ProtoTransactionCoreInfo instance
         */
        ProtoTransactionCoreInfo.create = function create(properties) {
            return new ProtoTransactionCoreInfo(properties);
        };

        /**
         * Encodes the specified ProtoTransactionCoreInfo message. Does not implicitly {@link ZilliqaMessage.ProtoTransactionCoreInfo.verify|verify} messages.
         * @function encode
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @static
         * @param {ZilliqaMessage.IProtoTransactionCoreInfo} message ProtoTransactionCoreInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProtoTransactionCoreInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.version);
            if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.nonce);
            if (message.toaddr != null && Object.hasOwnProperty.call(message, "toaddr"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.toaddr);
            if (message.senderpubkey != null && Object.hasOwnProperty.call(message, "senderpubkey"))
                $root.ZilliqaMessage.ByteArray.encode(message.senderpubkey, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                $root.ZilliqaMessage.ByteArray.encode(message.amount, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.gasprice != null && Object.hasOwnProperty.call(message, "gasprice"))
                $root.ZilliqaMessage.ByteArray.encode(message.gasprice, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.gaslimit != null && Object.hasOwnProperty.call(message, "gaslimit"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.gaslimit);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.code);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.data);
            return writer;
        };

        /**
         * Encodes the specified ProtoTransactionCoreInfo message, length delimited. Does not implicitly {@link ZilliqaMessage.ProtoTransactionCoreInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @static
         * @param {ZilliqaMessage.IProtoTransactionCoreInfo} message ProtoTransactionCoreInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProtoTransactionCoreInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProtoTransactionCoreInfo message from the specified reader or buffer.
         * @function decode
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ZilliqaMessage.ProtoTransactionCoreInfo} ProtoTransactionCoreInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProtoTransactionCoreInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZilliqaMessage.ProtoTransactionCoreInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.version = reader.uint32();
                    break;
                case 2:
                    message.nonce = reader.uint64();
                    break;
                case 3:
                    message.toaddr = reader.bytes();
                    break;
                case 4:
                    message.senderpubkey = $root.ZilliqaMessage.ByteArray.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.amount = $root.ZilliqaMessage.ByteArray.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.gasprice = $root.ZilliqaMessage.ByteArray.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.gaslimit = reader.uint64();
                    break;
                case 8:
                    message.code = reader.bytes();
                    break;
                case 9:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProtoTransactionCoreInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ZilliqaMessage.ProtoTransactionCoreInfo} ProtoTransactionCoreInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProtoTransactionCoreInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProtoTransactionCoreInfo message.
         * @function verify
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProtoTransactionCoreInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            if (message.nonce != null && message.hasOwnProperty("nonce"))
                if (!$util.isInteger(message.nonce) && !(message.nonce && $util.isInteger(message.nonce.low) && $util.isInteger(message.nonce.high)))
                    return "nonce: integer|Long expected";
            if (message.toaddr != null && message.hasOwnProperty("toaddr"))
                if (!(message.toaddr && typeof message.toaddr.length === "number" || $util.isString(message.toaddr)))
                    return "toaddr: buffer expected";
            if (message.senderpubkey != null && message.hasOwnProperty("senderpubkey")) {
                var error = $root.ZilliqaMessage.ByteArray.verify(message.senderpubkey);
                if (error)
                    return "senderpubkey." + error;
            }
            if (message.amount != null && message.hasOwnProperty("amount")) {
                var error = $root.ZilliqaMessage.ByteArray.verify(message.amount);
                if (error)
                    return "amount." + error;
            }
            if (message.gasprice != null && message.hasOwnProperty("gasprice")) {
                var error = $root.ZilliqaMessage.ByteArray.verify(message.gasprice);
                if (error)
                    return "gasprice." + error;
            }
            if (message.gaslimit != null && message.hasOwnProperty("gaslimit"))
                if (!$util.isInteger(message.gaslimit) && !(message.gaslimit && $util.isInteger(message.gaslimit.low) && $util.isInteger(message.gaslimit.high)))
                    return "gaslimit: integer|Long expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!(message.code && typeof message.code.length === "number" || $util.isString(message.code)))
                    return "code: buffer expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            return null;
        };

        /**
         * Creates a ProtoTransactionCoreInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ZilliqaMessage.ProtoTransactionCoreInfo} ProtoTransactionCoreInfo
         */
        ProtoTransactionCoreInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.ZilliqaMessage.ProtoTransactionCoreInfo)
                return object;
            var message = new $root.ZilliqaMessage.ProtoTransactionCoreInfo();
            if (object.version != null)
                message.version = object.version >>> 0;
            if (object.nonce != null)
                if ($util.Long)
                    (message.nonce = $util.Long.fromValue(object.nonce)).unsigned = true;
                else if (typeof object.nonce === "string")
                    message.nonce = parseInt(object.nonce, 10);
                else if (typeof object.nonce === "number")
                    message.nonce = object.nonce;
                else if (typeof object.nonce === "object")
                    message.nonce = new $util.LongBits(object.nonce.low >>> 0, object.nonce.high >>> 0).toNumber(true);
            if (object.toaddr != null)
                if (typeof object.toaddr === "string")
                    $util.base64.decode(object.toaddr, message.toaddr = $util.newBuffer($util.base64.length(object.toaddr)), 0);
                else if (object.toaddr.length)
                    message.toaddr = object.toaddr;
            if (object.senderpubkey != null) {
                if (typeof object.senderpubkey !== "object")
                    throw TypeError(".ZilliqaMessage.ProtoTransactionCoreInfo.senderpubkey: object expected");
                message.senderpubkey = $root.ZilliqaMessage.ByteArray.fromObject(object.senderpubkey);
            }
            if (object.amount != null) {
                if (typeof object.amount !== "object")
                    throw TypeError(".ZilliqaMessage.ProtoTransactionCoreInfo.amount: object expected");
                message.amount = $root.ZilliqaMessage.ByteArray.fromObject(object.amount);
            }
            if (object.gasprice != null) {
                if (typeof object.gasprice !== "object")
                    throw TypeError(".ZilliqaMessage.ProtoTransactionCoreInfo.gasprice: object expected");
                message.gasprice = $root.ZilliqaMessage.ByteArray.fromObject(object.gasprice);
            }
            if (object.gaslimit != null)
                if ($util.Long)
                    (message.gaslimit = $util.Long.fromValue(object.gaslimit)).unsigned = true;
                else if (typeof object.gaslimit === "string")
                    message.gaslimit = parseInt(object.gaslimit, 10);
                else if (typeof object.gaslimit === "number")
                    message.gaslimit = object.gaslimit;
                else if (typeof object.gaslimit === "object")
                    message.gaslimit = new $util.LongBits(object.gaslimit.low >>> 0, object.gaslimit.high >>> 0).toNumber(true);
            if (object.code != null)
                if (typeof object.code === "string")
                    $util.base64.decode(object.code, message.code = $util.newBuffer($util.base64.length(object.code)), 0);
                else if (object.code.length)
                    message.code = object.code;
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length)
                    message.data = object.data;
            return message;
        };

        /**
         * Creates a plain object from a ProtoTransactionCoreInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @static
         * @param {ZilliqaMessage.ProtoTransactionCoreInfo} message ProtoTransactionCoreInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProtoTransactionCoreInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.version = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.nonce = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.nonce = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.toaddr = "";
                else {
                    object.toaddr = [];
                    if (options.bytes !== Array)
                        object.toaddr = $util.newBuffer(object.toaddr);
                }
                object.senderpubkey = null;
                object.amount = null;
                object.gasprice = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.gaslimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gaslimit = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.code = "";
                else {
                    object.code = [];
                    if (options.bytes !== Array)
                        object.code = $util.newBuffer(object.code);
                }
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.nonce != null && message.hasOwnProperty("nonce"))
                if (typeof message.nonce === "number")
                    object.nonce = options.longs === String ? String(message.nonce) : message.nonce;
                else
                    object.nonce = options.longs === String ? $util.Long.prototype.toString.call(message.nonce) : options.longs === Number ? new $util.LongBits(message.nonce.low >>> 0, message.nonce.high >>> 0).toNumber(true) : message.nonce;
            if (message.toaddr != null && message.hasOwnProperty("toaddr"))
                object.toaddr = options.bytes === String ? $util.base64.encode(message.toaddr, 0, message.toaddr.length) : options.bytes === Array ? Array.prototype.slice.call(message.toaddr) : message.toaddr;
            if (message.senderpubkey != null && message.hasOwnProperty("senderpubkey"))
                object.senderpubkey = $root.ZilliqaMessage.ByteArray.toObject(message.senderpubkey, options);
            if (message.amount != null && message.hasOwnProperty("amount"))
                object.amount = $root.ZilliqaMessage.ByteArray.toObject(message.amount, options);
            if (message.gasprice != null && message.hasOwnProperty("gasprice"))
                object.gasprice = $root.ZilliqaMessage.ByteArray.toObject(message.gasprice, options);
            if (message.gaslimit != null && message.hasOwnProperty("gaslimit"))
                if (typeof message.gaslimit === "number")
                    object.gaslimit = options.longs === String ? String(message.gaslimit) : message.gaslimit;
                else
                    object.gaslimit = options.longs === String ? $util.Long.prototype.toString.call(message.gaslimit) : options.longs === Number ? new $util.LongBits(message.gaslimit.low >>> 0, message.gaslimit.high >>> 0).toNumber(true) : message.gaslimit;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = options.bytes === String ? $util.base64.encode(message.code, 0, message.code.length) : options.bytes === Array ? Array.prototype.slice.call(message.code) : message.code;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            return object;
        };

        /**
         * Converts this ProtoTransactionCoreInfo to JSON.
         * @function toJSON
         * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProtoTransactionCoreInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ProtoTransactionCoreInfo;
    })();

    ZilliqaMessage.ProtoTransaction = (function() {

        /**
         * Properties of a ProtoTransaction.
         * @memberof ZilliqaMessage
         * @interface IProtoTransaction
         * @property {Uint8Array|null} [tranid] ProtoTransaction tranid
         * @property {ZilliqaMessage.IProtoTransactionCoreInfo|null} [info] ProtoTransaction info
         * @property {ZilliqaMessage.IByteArray|null} [signature] ProtoTransaction signature
         */

        /**
         * Constructs a new ProtoTransaction.
         * @memberof ZilliqaMessage
         * @classdesc Represents a ProtoTransaction.
         * @implements IProtoTransaction
         * @constructor
         * @param {ZilliqaMessage.IProtoTransaction=} [properties] Properties to set
         */
        function ProtoTransaction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProtoTransaction tranid.
         * @member {Uint8Array} tranid
         * @memberof ZilliqaMessage.ProtoTransaction
         * @instance
         */
        ProtoTransaction.prototype.tranid = $util.newBuffer([]);

        /**
         * ProtoTransaction info.
         * @member {ZilliqaMessage.IProtoTransactionCoreInfo|null|undefined} info
         * @memberof ZilliqaMessage.ProtoTransaction
         * @instance
         */
        ProtoTransaction.prototype.info = null;

        /**
         * ProtoTransaction signature.
         * @member {ZilliqaMessage.IByteArray|null|undefined} signature
         * @memberof ZilliqaMessage.ProtoTransaction
         * @instance
         */
        ProtoTransaction.prototype.signature = null;

        /**
         * Creates a new ProtoTransaction instance using the specified properties.
         * @function create
         * @memberof ZilliqaMessage.ProtoTransaction
         * @static
         * @param {ZilliqaMessage.IProtoTransaction=} [properties] Properties to set
         * @returns {ZilliqaMessage.ProtoTransaction} ProtoTransaction instance
         */
        ProtoTransaction.create = function create(properties) {
            return new ProtoTransaction(properties);
        };

        /**
         * Encodes the specified ProtoTransaction message. Does not implicitly {@link ZilliqaMessage.ProtoTransaction.verify|verify} messages.
         * @function encode
         * @memberof ZilliqaMessage.ProtoTransaction
         * @static
         * @param {ZilliqaMessage.IProtoTransaction} message ProtoTransaction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProtoTransaction.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.tranid != null && Object.hasOwnProperty.call(message, "tranid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.tranid);
            if (message.info != null && Object.hasOwnProperty.call(message, "info"))
                $root.ZilliqaMessage.ProtoTransactionCoreInfo.encode(message.info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
                $root.ZilliqaMessage.ByteArray.encode(message.signature, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ProtoTransaction message, length delimited. Does not implicitly {@link ZilliqaMessage.ProtoTransaction.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ZilliqaMessage.ProtoTransaction
         * @static
         * @param {ZilliqaMessage.IProtoTransaction} message ProtoTransaction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProtoTransaction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProtoTransaction message from the specified reader or buffer.
         * @function decode
         * @memberof ZilliqaMessage.ProtoTransaction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ZilliqaMessage.ProtoTransaction} ProtoTransaction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProtoTransaction.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZilliqaMessage.ProtoTransaction();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.tranid = reader.bytes();
                    break;
                case 2:
                    message.info = $root.ZilliqaMessage.ProtoTransactionCoreInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signature = $root.ZilliqaMessage.ByteArray.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProtoTransaction message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ZilliqaMessage.ProtoTransaction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ZilliqaMessage.ProtoTransaction} ProtoTransaction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProtoTransaction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProtoTransaction message.
         * @function verify
         * @memberof ZilliqaMessage.ProtoTransaction
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProtoTransaction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.tranid != null && message.hasOwnProperty("tranid"))
                if (!(message.tranid && typeof message.tranid.length === "number" || $util.isString(message.tranid)))
                    return "tranid: buffer expected";
            if (message.info != null && message.hasOwnProperty("info")) {
                var error = $root.ZilliqaMessage.ProtoTransactionCoreInfo.verify(message.info);
                if (error)
                    return "info." + error;
            }
            if (message.signature != null && message.hasOwnProperty("signature")) {
                var error = $root.ZilliqaMessage.ByteArray.verify(message.signature);
                if (error)
                    return "signature." + error;
            }
            return null;
        };

        /**
         * Creates a ProtoTransaction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ZilliqaMessage.ProtoTransaction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ZilliqaMessage.ProtoTransaction} ProtoTransaction
         */
        ProtoTransaction.fromObject = function fromObject(object) {
            if (object instanceof $root.ZilliqaMessage.ProtoTransaction)
                return object;
            var message = new $root.ZilliqaMessage.ProtoTransaction();
            if (object.tranid != null)
                if (typeof object.tranid === "string")
                    $util.base64.decode(object.tranid, message.tranid = $util.newBuffer($util.base64.length(object.tranid)), 0);
                else if (object.tranid.length)
                    message.tranid = object.tranid;
            if (object.info != null) {
                if (typeof object.info !== "object")
                    throw TypeError(".ZilliqaMessage.ProtoTransaction.info: object expected");
                message.info = $root.ZilliqaMessage.ProtoTransactionCoreInfo.fromObject(object.info);
            }
            if (object.signature != null) {
                if (typeof object.signature !== "object")
                    throw TypeError(".ZilliqaMessage.ProtoTransaction.signature: object expected");
                message.signature = $root.ZilliqaMessage.ByteArray.fromObject(object.signature);
            }
            return message;
        };

        /**
         * Creates a plain object from a ProtoTransaction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ZilliqaMessage.ProtoTransaction
         * @static
         * @param {ZilliqaMessage.ProtoTransaction} message ProtoTransaction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProtoTransaction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.tranid = "";
                else {
                    object.tranid = [];
                    if (options.bytes !== Array)
                        object.tranid = $util.newBuffer(object.tranid);
                }
                object.info = null;
                object.signature = null;
            }
            if (message.tranid != null && message.hasOwnProperty("tranid"))
                object.tranid = options.bytes === String ? $util.base64.encode(message.tranid, 0, message.tranid.length) : options.bytes === Array ? Array.prototype.slice.call(message.tranid) : message.tranid;
            if (message.info != null && message.hasOwnProperty("info"))
                object.info = $root.ZilliqaMessage.ProtoTransactionCoreInfo.toObject(message.info, options);
            if (message.signature != null && message.hasOwnProperty("signature"))
                object.signature = $root.ZilliqaMessage.ByteArray.toObject(message.signature, options);
            return object;
        };

        /**
         * Converts this ProtoTransaction to JSON.
         * @function toJSON
         * @memberof ZilliqaMessage.ProtoTransaction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProtoTransaction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ProtoTransaction;
    })();

    ZilliqaMessage.ProtoTransactionReceipt = (function() {

        /**
         * Properties of a ProtoTransactionReceipt.
         * @memberof ZilliqaMessage
         * @interface IProtoTransactionReceipt
         * @property {Uint8Array|null} [receipt] ProtoTransactionReceipt receipt
         * @property {number|Long|null} [cumgas] ProtoTransactionReceipt cumgas
         */

        /**
         * Constructs a new ProtoTransactionReceipt.
         * @memberof ZilliqaMessage
         * @classdesc Represents a ProtoTransactionReceipt.
         * @implements IProtoTransactionReceipt
         * @constructor
         * @param {ZilliqaMessage.IProtoTransactionReceipt=} [properties] Properties to set
         */
        function ProtoTransactionReceipt(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProtoTransactionReceipt receipt.
         * @member {Uint8Array} receipt
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @instance
         */
        ProtoTransactionReceipt.prototype.receipt = $util.newBuffer([]);

        /**
         * ProtoTransactionReceipt cumgas.
         * @member {number|Long} cumgas
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @instance
         */
        ProtoTransactionReceipt.prototype.cumgas = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ProtoTransactionReceipt instance using the specified properties.
         * @function create
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @static
         * @param {ZilliqaMessage.IProtoTransactionReceipt=} [properties] Properties to set
         * @returns {ZilliqaMessage.ProtoTransactionReceipt} ProtoTransactionReceipt instance
         */
        ProtoTransactionReceipt.create = function create(properties) {
            return new ProtoTransactionReceipt(properties);
        };

        /**
         * Encodes the specified ProtoTransactionReceipt message. Does not implicitly {@link ZilliqaMessage.ProtoTransactionReceipt.verify|verify} messages.
         * @function encode
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @static
         * @param {ZilliqaMessage.IProtoTransactionReceipt} message ProtoTransactionReceipt message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProtoTransactionReceipt.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.receipt != null && Object.hasOwnProperty.call(message, "receipt"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.receipt);
            if (message.cumgas != null && Object.hasOwnProperty.call(message, "cumgas"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.cumgas);
            return writer;
        };

        /**
         * Encodes the specified ProtoTransactionReceipt message, length delimited. Does not implicitly {@link ZilliqaMessage.ProtoTransactionReceipt.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @static
         * @param {ZilliqaMessage.IProtoTransactionReceipt} message ProtoTransactionReceipt message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProtoTransactionReceipt.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProtoTransactionReceipt message from the specified reader or buffer.
         * @function decode
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ZilliqaMessage.ProtoTransactionReceipt} ProtoTransactionReceipt
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProtoTransactionReceipt.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZilliqaMessage.ProtoTransactionReceipt();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.receipt = reader.bytes();
                    break;
                case 2:
                    message.cumgas = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProtoTransactionReceipt message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ZilliqaMessage.ProtoTransactionReceipt} ProtoTransactionReceipt
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProtoTransactionReceipt.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProtoTransactionReceipt message.
         * @function verify
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProtoTransactionReceipt.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.receipt != null && message.hasOwnProperty("receipt"))
                if (!(message.receipt && typeof message.receipt.length === "number" || $util.isString(message.receipt)))
                    return "receipt: buffer expected";
            if (message.cumgas != null && message.hasOwnProperty("cumgas"))
                if (!$util.isInteger(message.cumgas) && !(message.cumgas && $util.isInteger(message.cumgas.low) && $util.isInteger(message.cumgas.high)))
                    return "cumgas: integer|Long expected";
            return null;
        };

        /**
         * Creates a ProtoTransactionReceipt message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ZilliqaMessage.ProtoTransactionReceipt} ProtoTransactionReceipt
         */
        ProtoTransactionReceipt.fromObject = function fromObject(object) {
            if (object instanceof $root.ZilliqaMessage.ProtoTransactionReceipt)
                return object;
            var message = new $root.ZilliqaMessage.ProtoTransactionReceipt();
            if (object.receipt != null)
                if (typeof object.receipt === "string")
                    $util.base64.decode(object.receipt, message.receipt = $util.newBuffer($util.base64.length(object.receipt)), 0);
                else if (object.receipt.length)
                    message.receipt = object.receipt;
            if (object.cumgas != null)
                if ($util.Long)
                    (message.cumgas = $util.Long.fromValue(object.cumgas)).unsigned = true;
                else if (typeof object.cumgas === "string")
                    message.cumgas = parseInt(object.cumgas, 10);
                else if (typeof object.cumgas === "number")
                    message.cumgas = object.cumgas;
                else if (typeof object.cumgas === "object")
                    message.cumgas = new $util.LongBits(object.cumgas.low >>> 0, object.cumgas.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ProtoTransactionReceipt message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @static
         * @param {ZilliqaMessage.ProtoTransactionReceipt} message ProtoTransactionReceipt
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProtoTransactionReceipt.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.receipt = "";
                else {
                    object.receipt = [];
                    if (options.bytes !== Array)
                        object.receipt = $util.newBuffer(object.receipt);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.cumgas = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.cumgas = options.longs === String ? "0" : 0;
            }
            if (message.receipt != null && message.hasOwnProperty("receipt"))
                object.receipt = options.bytes === String ? $util.base64.encode(message.receipt, 0, message.receipt.length) : options.bytes === Array ? Array.prototype.slice.call(message.receipt) : message.receipt;
            if (message.cumgas != null && message.hasOwnProperty("cumgas"))
                if (typeof message.cumgas === "number")
                    object.cumgas = options.longs === String ? String(message.cumgas) : message.cumgas;
                else
                    object.cumgas = options.longs === String ? $util.Long.prototype.toString.call(message.cumgas) : options.longs === Number ? new $util.LongBits(message.cumgas.low >>> 0, message.cumgas.high >>> 0).toNumber(true) : message.cumgas;
            return object;
        };

        /**
         * Converts this ProtoTransactionReceipt to JSON.
         * @function toJSON
         * @memberof ZilliqaMessage.ProtoTransactionReceipt
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProtoTransactionReceipt.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ProtoTransactionReceipt;
    })();

    ZilliqaMessage.ProtoTransactionWithReceipt = (function() {

        /**
         * Properties of a ProtoTransactionWithReceipt.
         * @memberof ZilliqaMessage
         * @interface IProtoTransactionWithReceipt
         * @property {ZilliqaMessage.IProtoTransaction|null} [transaction] ProtoTransactionWithReceipt transaction
         * @property {ZilliqaMessage.IProtoTransactionReceipt|null} [receipt] ProtoTransactionWithReceipt receipt
         */

        /**
         * Constructs a new ProtoTransactionWithReceipt.
         * @memberof ZilliqaMessage
         * @classdesc Represents a ProtoTransactionWithReceipt.
         * @implements IProtoTransactionWithReceipt
         * @constructor
         * @param {ZilliqaMessage.IProtoTransactionWithReceipt=} [properties] Properties to set
         */
        function ProtoTransactionWithReceipt(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProtoTransactionWithReceipt transaction.
         * @member {ZilliqaMessage.IProtoTransaction|null|undefined} transaction
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @instance
         */
        ProtoTransactionWithReceipt.prototype.transaction = null;

        /**
         * ProtoTransactionWithReceipt receipt.
         * @member {ZilliqaMessage.IProtoTransactionReceipt|null|undefined} receipt
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @instance
         */
        ProtoTransactionWithReceipt.prototype.receipt = null;

        /**
         * Creates a new ProtoTransactionWithReceipt instance using the specified properties.
         * @function create
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @static
         * @param {ZilliqaMessage.IProtoTransactionWithReceipt=} [properties] Properties to set
         * @returns {ZilliqaMessage.ProtoTransactionWithReceipt} ProtoTransactionWithReceipt instance
         */
        ProtoTransactionWithReceipt.create = function create(properties) {
            return new ProtoTransactionWithReceipt(properties);
        };

        /**
         * Encodes the specified ProtoTransactionWithReceipt message. Does not implicitly {@link ZilliqaMessage.ProtoTransactionWithReceipt.verify|verify} messages.
         * @function encode
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @static
         * @param {ZilliqaMessage.IProtoTransactionWithReceipt} message ProtoTransactionWithReceipt message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProtoTransactionWithReceipt.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.transaction != null && Object.hasOwnProperty.call(message, "transaction"))
                $root.ZilliqaMessage.ProtoTransaction.encode(message.transaction, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.receipt != null && Object.hasOwnProperty.call(message, "receipt"))
                $root.ZilliqaMessage.ProtoTransactionReceipt.encode(message.receipt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ProtoTransactionWithReceipt message, length delimited. Does not implicitly {@link ZilliqaMessage.ProtoTransactionWithReceipt.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @static
         * @param {ZilliqaMessage.IProtoTransactionWithReceipt} message ProtoTransactionWithReceipt message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProtoTransactionWithReceipt.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProtoTransactionWithReceipt message from the specified reader or buffer.
         * @function decode
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ZilliqaMessage.ProtoTransactionWithReceipt} ProtoTransactionWithReceipt
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProtoTransactionWithReceipt.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZilliqaMessage.ProtoTransactionWithReceipt();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.transaction = $root.ZilliqaMessage.ProtoTransaction.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.receipt = $root.ZilliqaMessage.ProtoTransactionReceipt.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProtoTransactionWithReceipt message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ZilliqaMessage.ProtoTransactionWithReceipt} ProtoTransactionWithReceipt
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProtoTransactionWithReceipt.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProtoTransactionWithReceipt message.
         * @function verify
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProtoTransactionWithReceipt.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.transaction != null && message.hasOwnProperty("transaction")) {
                var error = $root.ZilliqaMessage.ProtoTransaction.verify(message.transaction);
                if (error)
                    return "transaction." + error;
            }
            if (message.receipt != null && message.hasOwnProperty("receipt")) {
                var error = $root.ZilliqaMessage.ProtoTransactionReceipt.verify(message.receipt);
                if (error)
                    return "receipt." + error;
            }
            return null;
        };

        /**
         * Creates a ProtoTransactionWithReceipt message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ZilliqaMessage.ProtoTransactionWithReceipt} ProtoTransactionWithReceipt
         */
        ProtoTransactionWithReceipt.fromObject = function fromObject(object) {
            if (object instanceof $root.ZilliqaMessage.ProtoTransactionWithReceipt)
                return object;
            var message = new $root.ZilliqaMessage.ProtoTransactionWithReceipt();
            if (object.transaction != null) {
                if (typeof object.transaction !== "object")
                    throw TypeError(".ZilliqaMessage.ProtoTransactionWithReceipt.transaction: object expected");
                message.transaction = $root.ZilliqaMessage.ProtoTransaction.fromObject(object.transaction);
            }
            if (object.receipt != null) {
                if (typeof object.receipt !== "object")
                    throw TypeError(".ZilliqaMessage.ProtoTransactionWithReceipt.receipt: object expected");
                message.receipt = $root.ZilliqaMessage.ProtoTransactionReceipt.fromObject(object.receipt);
            }
            return message;
        };

        /**
         * Creates a plain object from a ProtoTransactionWithReceipt message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @static
         * @param {ZilliqaMessage.ProtoTransactionWithReceipt} message ProtoTransactionWithReceipt
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProtoTransactionWithReceipt.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.transaction = null;
                object.receipt = null;
            }
            if (message.transaction != null && message.hasOwnProperty("transaction"))
                object.transaction = $root.ZilliqaMessage.ProtoTransaction.toObject(message.transaction, options);
            if (message.receipt != null && message.hasOwnProperty("receipt"))
                object.receipt = $root.ZilliqaMessage.ProtoTransactionReceipt.toObject(message.receipt, options);
            return object;
        };

        /**
         * Converts this ProtoTransactionWithReceipt to JSON.
         * @function toJSON
         * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProtoTransactionWithReceipt.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ProtoTransactionWithReceipt;
    })();

    return ZilliqaMessage;
})();

module.exports = $root;
